export const ENTITY_PREFIX = {
    SHOW: "SH",
    CHANNEL: "LC",
    INTERACTIVE_POLL: "IP",
    INTERACTIVE_FREEFORM: "IF"
} as const;
export type EntityPrefix = (typeof ENTITY_PREFIX)[keyof typeof ENTITY_PREFIX];

export type TypedEntityId<P extends EntityPrefix = EntityPrefix> = `${P}:${string}`;

export type PollId = TypedEntityId<typeof ENTITY_PREFIX.INTERACTIVE_POLL>;
export type FreeformId = TypedEntityId<typeof ENTITY_PREFIX.INTERACTIVE_FREEFORM>;

export function isPollId(id: string): id is PollId {
    return id.startsWith(`${ENTITY_PREFIX.INTERACTIVE_POLL}:`);
}

export function isFreeformId(id: string): id is FreeformId {
    return id.startsWith(`${ENTITY_PREFIX.INTERACTIVE_FREEFORM}:`);
}

/**
 * True for an id carrying one of `prefixes`, narrowing it to that entity type. Callers pass the
 * prefixes that make sense for them — most fields hold one kind of entity, not any of the four.
 * Matching mirrors the backend's `EntityIdHelper`, including the exact-prefix rule that rejects
 * near-misses like `SHA:<id>`.
 */
export function hasEntityPrefix<P extends EntityPrefix>(id: string, prefixes: readonly P[]): id is TypedEntityId<P> {
    return prefixes.some(prefix => id.startsWith(`${prefix}:`));
}

export function stripPrefix(id: TypedEntityId): string {
    return id.slice(id.indexOf(":") + 1);
}
